<ul class="alternative-list">
  <slot />
</ul>

<style>
  .alternative-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
</style>
